import * as React from "react";
import { Typography } from "@mui/material";

const DemoFigmaTitle = ({ children }: { children: string }) => (
  <Typography variant="h6" color="primary.text" component="div">
    ({children})
  </Typography>
);

export default DemoFigmaTitle;
